import { render, staticRenderFns } from "./OptionsDisplayApi.vue?vue&type=template&id=0254ed55&"
import script from "./OptionsDisplayApi.vue?vue&type=script&lang=js&"
export * from "./OptionsDisplayApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports